import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1554d288")

_pushScopeId("data-v-1554d288")
const _hoisted_1 = {
  key: 0,
  class: "select-wallet"
}
const _hoisted_2 = {
  key: 1,
  class: "wallet-info"
}
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "tabsContent" }
const _hoisted_5 = { class: "tabsContent" }
const _hoisted_6 = { class: "tabsContent" }
const _hoisted_7 = { class: "tabsContent" }
const _hoisted_8 = { class: "tabsContent" }
const _hoisted_9 = { class: "tabsContent" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "reward-main" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "claimable-info inner-card" }
const _hoisted_14 = { class: "text-wrap" }
const _hoisted_15 = { class: "grey-color" }
const _hoisted_16 = { style: {"font-size":"20px"} }
const _hoisted_17 = { class: "grey-color" }
const _hoisted_18 = { class: "other-info" }
const _hoisted_19 = { class: "row-wrap" }
const _hoisted_20 = { class: "grey-color" }
const _hoisted_21 = { class: "row-wrap" }
const _hoisted_22 = { class: "grey-color" }
const _hoisted_23 = {
  key: 0,
  class: "button-wrap"
}
const _hoisted_24 = { style: {"white-space":"nowrap","color":"#A1B7EE"} }
const _hoisted_25 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "circle-warn" }, [
  /*#__PURE__*/_createVNode("span", null, "!")
], -1)
const _hoisted_27 = { class: "direct-claim-warning" }
const _hoisted_28 = { style: {"margin-top":"2px"} }
const _hoisted_29 = { class: "stake-larix" }
const _hoisted_30 = { class: "multiple" }
const _hoisted_31 = { class: "multiple-title" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "multiple-splitLine" }, null, -1)
const _hoisted_33 = { class: "subtitle" }
const _hoisted_34 = { class: "larix-amount-wrap" }
const _hoisted_35 = { class: "info-card inner-card" }
const _hoisted_36 = { class: "grey-color" }
const _hoisted_37 = { class: "data" }
const _hoisted_38 = { class: "combinator" }
const _hoisted_39 = { class: "text grey-color" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "gg-arrow-long-right" }, null, -1)
const _hoisted_41 = { class: "text grey-color" }
const _hoisted_42 = { class: "info-card inner-card" }
const _hoisted_43 = { class: "grey-color" }
const _hoisted_44 = { class: "data" }
const _hoisted_45 = {
  class: "grey-color",
  style: {"padding":"20px 8px 2px"}
}
const _hoisted_46 = { class: "slider-wrap sliderBody" }
const _hoisted_47 = { class: "sliderRunway" }
const _hoisted_48 = { class: "sliderMarks" }
const _hoisted_49 = {
  class: "grey-color",
  style: {"display":"flex","justify-content":"space-between","padding":"2px 8px"}
}
const _hoisted_50 = /*#__PURE__*/_createVNode("div", null, "0.00 LARIX", -1)
const _hoisted_51 = {
  class: "grey-color",
  style: {"display":"flex","justify-content":"space-between","padding":"2px 8px"}
}
const _hoisted_52 = { style: {"border-top":"1px solid #2B3866","margin":"22px 8px"} }
const _hoisted_53 = { style: {"display":"flex","justify-content":"space-between","margin-top":"18px"} }
const _hoisted_54 = { class: "grey-color" }
const _hoisted_55 = { style: {"display":"flex","justify-content":"space-between","margin-top":"14px"} }
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "grey-color" }, "LARIX-USDC (APR)", -1)
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "reward-main" }
const _hoisted_59 = { class: "claimable-info inner-card" }
const _hoisted_60 = { class: "text-wrap" }
const _hoisted_61 = { class: "grey-color" }
const _hoisted_62 = { style: {"font-size":"20px"} }
const _hoisted_63 = { class: "grey-color" }
const _hoisted_64 = { class: "other-info" }
const _hoisted_65 = { class: "row-wrap" }
const _hoisted_66 = { class: "grey-color" }
const _hoisted_67 = { class: "row-wrap" }
const _hoisted_68 = { class: "grey-color" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { style: {"white-space":"nowrap"} }
const _hoisted_71 = { key: 2 }
const _hoisted_72 = { class: "reward-main" }
const _hoisted_73 = { class: "claimable-info inner-card" }
const _hoisted_74 = { class: "text-wrap" }
const _hoisted_75 = { class: "grey-color" }
const _hoisted_76 = { style: {"font-size":"20px"} }
const _hoisted_77 = { class: "grey-color" }
const _hoisted_78 = { class: "other-info" }
const _hoisted_79 = { class: "row-wrap" }
const _hoisted_80 = { class: "grey-color" }
const _hoisted_81 = { class: "row-wrap" }
const _hoisted_82 = { class: "grey-color" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { style: {"white-space":"nowrap"} }
const _hoisted_85 = { key: 3 }
const _hoisted_86 = { class: "reward-main" }
const _hoisted_87 = { class: "claimable-info inner-card" }
const _hoisted_88 = { class: "text-wrap" }
const _hoisted_89 = { class: "grey-color" }
const _hoisted_90 = { style: {"font-size":"20px"} }
const _hoisted_91 = { class: "grey-color" }
const _hoisted_92 = { class: "other-info" }
const _hoisted_93 = { class: "row-wrap" }
const _hoisted_94 = { class: "grey-color" }
const _hoisted_95 = { class: "row-wrap" }
const _hoisted_96 = { class: "grey-color" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { style: {"white-space":"nowrap"} }
const _hoisted_99 = { key: 4 }
const _hoisted_100 = { class: "reward-main" }
const _hoisted_101 = { class: "claimable-info inner-card" }
const _hoisted_102 = { class: "text-wrap" }
const _hoisted_103 = { class: "grey-color" }
const _hoisted_104 = { style: {"font-size":"20px"} }
const _hoisted_105 = { class: "grey-color" }
const _hoisted_106 = { class: "other-info" }
const _hoisted_107 = { class: "row-wrap" }
const _hoisted_108 = { class: "grey-color" }
const _hoisted_109 = { class: "row-wrap" }
const _hoisted_110 = { class: "grey-color" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { style: {"white-space":"nowrap"} }
const _hoisted_113 = { key: 5 }
const _hoisted_114 = { class: "reward-main" }
const _hoisted_115 = { class: "claimable-info inner-card" }
const _hoisted_116 = { class: "text-wrap" }
const _hoisted_117 = { class: "grey-color" }
const _hoisted_118 = { style: {"font-size":"20px"} }
const _hoisted_119 = { class: "grey-color" }
const _hoisted_120 = { class: "other-info" }
const _hoisted_121 = { class: "row-wrap" }
const _hoisted_122 = { class: "grey-color" }
const _hoisted_123 = { class: "row-wrap" }
const _hoisted_124 = { class: "grey-color" }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { style: {"white-space":"nowrap"} }
const _hoisted_127 = {
  key: 0,
  class: "select-wallet"
}
const _hoisted_128 = {
  key: 1,
  class: "wallet-info-app"
}
const _hoisted_129 = { class: "appTabs" }
const _hoisted_130 = { class: "appTabsContent" }
const _hoisted_131 = { class: "appTabsContent" }
const _hoisted_132 = { class: "appTabsContent" }
const _hoisted_133 = { class: "appTabsContent" }
const _hoisted_134 = { class: "appTabsContent" }
const _hoisted_135 = { class: "appTabsContent" }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { class: "reward-main-app" }
const _hoisted_138 = { key: 0 }
const _hoisted_139 = { class: "claimable-info-app inner-card" }
const _hoisted_140 = { class: "text-wrap-app" }
const _hoisted_141 = { class: "grey-color" }
const _hoisted_142 = { style: {"font-size":"14px"} }
const _hoisted_143 = { class: "grey-color" }
const _hoisted_144 = { class: "other-info-app" }
const _hoisted_145 = { class: "row-wrap-app" }
const _hoisted_146 = { class: "grey-color" }
const _hoisted_147 = { class: "row-wrap-app" }
const _hoisted_148 = { class: "grey-color" }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = { class: "button-wrap-app" }
const _hoisted_151 = { style: {"white-space":"nowrap","color":"#A1B7EE"} }
const _hoisted_152 = { style: {"white-space":"nowrap","color":"#A1B7EE"} }
const _hoisted_153 = { class: "button-wrap-app" }
const _hoisted_154 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_155 = /*#__PURE__*/_createVNode("div", { class: "circle-warn-app" }, [
  /*#__PURE__*/_createVNode("span", null, "!")
], -1)
const _hoisted_156 = { class: "direct-claim-warning-app" }
const _hoisted_157 = { style: {"margin-top":"2px"} }
const _hoisted_158 = { class: "stake-larix-app" }
const _hoisted_159 = { class: "multiple" }
const _hoisted_160 = { class: "multiple-title" }
const _hoisted_161 = /*#__PURE__*/_createVNode("p", { class: "multiple-splitLine" }, null, -1)
const _hoisted_162 = { class: "subtitle" }
const _hoisted_163 = { class: "larix-amount-wrap" }
const _hoisted_164 = { class: "info-card inner-card" }
const _hoisted_165 = { class: "grey-color" }
const _hoisted_166 = { class: "data" }
const _hoisted_167 = { class: "combinator" }
const _hoisted_168 = { class: "text grey-color" }
const _hoisted_169 = /*#__PURE__*/_createVNode("div", { class: "gg-arrow-long-right" }, null, -1)
const _hoisted_170 = { class: "text grey-color" }
const _hoisted_171 = { class: "info-card inner-card" }
const _hoisted_172 = { class: "grey-color" }
const _hoisted_173 = { class: "data" }
const _hoisted_174 = {
  class: "grey-color",
  style: {"padding":"12px 4px 2px","font-size":"11px"}
}
const _hoisted_175 = { class: "slider-wrap sliderBody" }
const _hoisted_176 = { class: "sliderRunway" }
const _hoisted_177 = { class: "sliderMarks" }
const _hoisted_178 = {
  class: "grey-color",
  style: {"display":"flex","justify-content":"space-between","padding":"2px 4px","font-size":"10px"}
}
const _hoisted_179 = /*#__PURE__*/_createVNode("div", null, "0.00 LARIX", -1)
const _hoisted_180 = {
  class: "grey-color",
  style: {"display":"flex","justify-content":"space-between","padding":"2px 4px","font-size":"10px"}
}
const _hoisted_181 = { style: {"border-top":"1px solid #2B3866","margin":"22px 4px"} }
const _hoisted_182 = { style: {"display":"flex","justify-content":"space-between","margin-top":"18px","font-size":"12px"} }
const _hoisted_183 = { class: "grey-color" }
const _hoisted_184 = { style: {"display":"flex","justify-content":"space-between","margin-top":"14px","font-size":"12px"} }
const _hoisted_185 = /*#__PURE__*/_createVNode("div", { class: "grey-color" }, "LARIX-USDC (APR)", -1)
const _hoisted_186 = { key: 1 }
const _hoisted_187 = { class: "reward-main-app" }
const _hoisted_188 = { class: "claimable-info-app inner-card" }
const _hoisted_189 = { class: "text-wrap-app" }
const _hoisted_190 = { class: "grey-color" }
const _hoisted_191 = { style: {"font-size":"14px"} }
const _hoisted_192 = { class: "grey-color" }
const _hoisted_193 = { class: "other-info-app" }
const _hoisted_194 = { class: "row-wrap-app" }
const _hoisted_195 = { class: "grey-color" }
const _hoisted_196 = { class: "row-wrap-app" }
const _hoisted_197 = { class: "grey-color" }
const _hoisted_198 = { key: 0 }
const _hoisted_199 = { class: "button-wrap-app" }
const _hoisted_200 = { style: {"white-space":"nowrap"} }
const _hoisted_201 = { key: 2 }
const _hoisted_202 = { class: "reward-main-app" }
const _hoisted_203 = { class: "claimable-info-app inner-card" }
const _hoisted_204 = { class: "text-wrap-app" }
const _hoisted_205 = { class: "grey-color" }
const _hoisted_206 = { style: {"font-size":"14px"} }
const _hoisted_207 = { class: "grey-color" }
const _hoisted_208 = { class: "other-info-app" }
const _hoisted_209 = { class: "row-wrap-app" }
const _hoisted_210 = { class: "grey-color" }
const _hoisted_211 = { class: "row-wrap-app" }
const _hoisted_212 = { class: "grey-color" }
const _hoisted_213 = { key: 0 }
const _hoisted_214 = { class: "button-wrap-app" }
const _hoisted_215 = { style: {"white-space":"nowrap"} }
const _hoisted_216 = { key: 3 }
const _hoisted_217 = { class: "reward-main-app" }
const _hoisted_218 = { class: "claimable-info-app inner-card" }
const _hoisted_219 = { class: "text-wrap-app" }
const _hoisted_220 = { class: "grey-color" }
const _hoisted_221 = { style: {"font-size":"14px"} }
const _hoisted_222 = { class: "grey-color" }
const _hoisted_223 = { class: "other-info-app" }
const _hoisted_224 = { class: "row-wrap-app" }
const _hoisted_225 = { class: "grey-color" }
const _hoisted_226 = { class: "row-wrap-app" }
const _hoisted_227 = { class: "grey-color" }
const _hoisted_228 = { key: 0 }
const _hoisted_229 = { class: "button-wrap-app" }
const _hoisted_230 = { style: {"white-space":"nowrap"} }
const _hoisted_231 = { key: 4 }
const _hoisted_232 = { class: "reward-main-app" }
const _hoisted_233 = { class: "claimable-info-app inner-card" }
const _hoisted_234 = { class: "text-wrap-app" }
const _hoisted_235 = { class: "grey-color" }
const _hoisted_236 = { style: {"font-size":"14px"} }
const _hoisted_237 = { class: "grey-color" }
const _hoisted_238 = { class: "other-info-app" }
const _hoisted_239 = { class: "row-wrap-app" }
const _hoisted_240 = { class: "grey-color" }
const _hoisted_241 = { class: "row-wrap-app" }
const _hoisted_242 = { class: "grey-color" }
const _hoisted_243 = { key: 0 }
const _hoisted_244 = { class: "button-wrap-app" }
const _hoisted_245 = { style: {"white-space":"nowrap"} }
const _hoisted_246 = { key: 5 }
const _hoisted_247 = { class: "reward-main-app" }
const _hoisted_248 = { class: "claimable-info-app inner-card" }
const _hoisted_249 = { class: "text-wrap-app" }
const _hoisted_250 = { class: "grey-color" }
const _hoisted_251 = { style: {"font-size":"14px"} }
const _hoisted_252 = { class: "grey-color" }
const _hoisted_253 = { class: "other-info-app" }
const _hoisted_254 = { class: "row-wrap-app" }
const _hoisted_255 = { class: "grey-color" }
const _hoisted_256 = { class: "row-wrap-app" }
const _hoisted_257 = { class: "grey-color" }
const _hoisted_258 = { key: 0 }
const _hoisted_259 = { class: "button-wrap-app" }
const _hoisted_260 = { style: {"white-space":"nowrap"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_space = _resolveComponent("q-space")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_card_section = _resolveComponent("q-card-section")
  const _component_q_slider = _resolveComponent("q-slider")
  const _component_q_card = _resolveComponent("q-card")
  const _component_q_dialog = _resolveComponent("q-dialog")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.rewardDialogVisible,
    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.rewardDialogVisible = $event))
  }, {
    default: _withId(() => [
      _createVNode(_component_q_card, { class: "reward gt-sm" }, {
        default: _withId(() => [
          _createVNode(_component_q_card_section, { class: "row items-center rewardTitle" }, {
            default: _withId(() => [
              _createVNode("div", null, _toDisplayString(_ctx.dialogTitle), 1),
              _createVNode(_component_q_space),
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: ""
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "rewardBody" }, {
            default: _withId(() => [
              (!_ctx.walletAddress)
                ? (_openBlock(), _createBlock("div", _hoisted_1, [
                    _createVNode("div", null, _toDisplayString(_ctx.t('wallet.connectToAWallet')), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createVNode("div", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.poolType = 'main';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='main'?'active':'inactive'
                        }, _toDisplayString(_ctx.t("reward.main")), 3)
                      ]),
                      _createVNode("div", _hoisted_5, [
                        _createVNode("div", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.poolType = 'larix';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='larix'?'active':'inactive'
                        }, "Larix", 2)
                      ]),
                      _createVNode("div", _hoisted_6, [
                        _createVNode("div", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.poolType = 'stepn';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='stepn'?'active':'inactive'
                        }, "Stepn", 2)
                      ]),
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.poolType = 'step';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='step'?'active':'inactive'
                        }, "Step", 2)
                      ]),
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.poolType = 'xSol';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='xSol'?'active':'inactive'
                        }, "xSOL", 2)
                      ]),
                      _createVNode("div", _hoisted_9, [
                        _createVNode("div", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.poolType = 'bonfida';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='bonfida'?'active':'inactive'
                        }, "Bonfida", 2)
                      ])
                    ]),
                    (_ctx.poolType==='main')
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          _withDirectives(_createVNode("div", _hoisted_11, [
                            (!_ctx.confirmingClaim)
                              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                  _createVNode("div", _hoisted_13, [
                                    _createVNode("img", {
                                      src: _ctx.larixImg,
                                      width: "78",
                                      height: "78",
                                      style: {"border-radius":"50%"}
                                    }, null, 8, ["src"]),
                                    _createVNode("div", _hoisted_14, [
                                      _createVNode("div", _hoisted_15, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward,6)) + " LARIX", 1),
                                      _createVNode("div", _hoisted_17, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_18, [
                                    _createVNode("div", _hoisted_19, [
                                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                      _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                    ]),
                                    _createVNode("div", _hoisted_21, [
                                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.t('wallet.price')), 1),
                                      _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                    ])
                                  ]),
                                  (_ctx.userLarixReward.isGreaterThan(0))
                                    ? (_openBlock(), _createBlock("div", _hoisted_23, [
                                        _createVNode(_component_q_btn, {
                                          round: "",
                                          "no-caps": "",
                                          class: "button grey-button",
                                          style: {"width":"unset","padding":"0 22px","margin-right":"10px","margin-bottom":"20px"},
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmingClaim = true))
                                        }, {
                                          default: _withId(() => [
                                            _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_btn, {
                                          round: "",
                                          "no-caps": "",
                                          class: "button",
                                          style: {"margin-bottom":"20px"},
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.step = 2,_ctx.rewardMultiplier = 10))
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('reward.reward') + ' X ' + 10), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_btn, {
                                          round: "",
                                          "no-caps": "",
                                          class: "button gt-sm",
                                          style: {"margin-bottom":"20px","margin-left":"10px"},
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.step = 2 ,_ctx.rewardMultiplier = 5))
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('reward.reward') + ' X ' + 5), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        rounded: "",
                                        "no-caps": "",
                                        disabled: "",
                                        class: "button grey-button",
                                        style: {"margin-bottom":"20px"}
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                        ]),
                                        _: 1
                                      }))
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_25, [
                                  _hoisted_26,
                                  _createVNode("div", _hoisted_27, [
                                    _createVNode("div", null, _toDisplayString(_ctx.t('reward.youWillLose1',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(9),6)})), 1),
                                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.t('reward.youWillLose2',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(9),6)})), 1)
                                  ]),
                                  _createVNode(_component_q_btn, {
                                    round: "",
                                    "no-caps": "",
                                    class: "button",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.step = 2))
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('reward.earn2x',{x:10})) + "(" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward.times(10),6)) + ") ", 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_btn, {
                                    round: "",
                                    "no-caps": "",
                                    class: "button grey-button bottom-btn",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.claimReward('main')))
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('reward.claimDirectly')) + "(" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward,6)) + ") ", 1)
                                    ]),
                                    _: 1
                                  })
                                ]))
                          ], 512), [
                            [_vShow, _ctx.step === 1]
                          ]),
                          _withDirectives(_createVNode("div", _hoisted_29, [
                            _createVNode("div", _hoisted_30, [
                              _createVNode("p", _hoisted_31, _toDisplayString(_ctx.t('reward.chooseToReceive')), 1),
                              _createVNode(_component_q_btn, {
                                class: ["multiple-btn", _ctx.rewardMultiplier===10?'multiple-btnActive':''],
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setRewardMultiplier(10))),
                                "no-caps": ""
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('reward.reward')) + " ×10", 1)
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              _createVNode(_component_q_btn, {
                                class: ["multiple-btn", _ctx.rewardMultiplier===5?'multiple-btnActive':''],
                                style: {"margin-left":"14px"},
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setRewardMultiplier(5))),
                                "no-caps": ""
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('reward.reward')) + " ×5", 1)
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              _hoisted_32
                            ]),
                            _createVNode("div", _hoisted_33, _toDisplayString(_ctx.t('reward.maximumReceive',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(_ctx.rewardMultiplier),6)})) + " (" + _toDisplayString(_ctx.rewardMultiplier) + "X)", 1),
                            _createVNode("div", _hoisted_34, [
                              _createVNode("div", _hoisted_35, [
                                _createVNode("div", _hoisted_36, _toDisplayString(_ctx.t('reward.currentRewards')) + " (LARIX)", 1),
                                _createVNode("div", _hoisted_37, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userStakeLarixAmount,6)), 1)
                              ]),
                              _createVNode("div", _hoisted_38, [
                                _createVNode("div", _hoisted_39, _toDisplayString(_ctx.t('reward.stake')), 1),
                                _hoisted_40,
                                _createVNode("div", _hoisted_41, _toDisplayString(_ctx.stakePeriod) + " " + _toDisplayString(_ctx.t('reward.days')), 1)
                              ]),
                              _createVNode("div", _hoisted_42, [
                                _createVNode("div", _hoisted_43, _toDisplayString(_ctx.t('reward.expiredReward')) + " (LARIX)", 1),
                                _createVNode("div", _hoisted_44, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userTotalStakeLarixAmount,6)), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_45, _toDisplayString(_ctx.t('reward.walletBalance')) + " " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userUsdcBalance,2)) + " USDC, " + _toDisplayString(_ctx.t('reward.maximumReceive',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(_ctx.rewardMultiplier),6)})), 1),
                            _createVNode("div", _hoisted_46, [
                              _createVNode("div", _hoisted_47, [
                                _createVNode(_component_q_slider, {
                                  modelValue: _ctx.sliderStakePercent,
                                  "onUpdate:modelValue": [
                                    _cache[14] || (_cache[14] = ($event: any) => (_ctx.sliderStakePercent = $event)),
                                    _cache[15] || (_cache[15] = ($event: any) => (_ctx.sliderStakePercentChange($event)))
                                  ],
                                  style: {"height":"6px","z-index":"2","padding":"0 2px"},
                                  min: 0,
                                  max: 100
                                }, null, 8, ["modelValue"]),
                                _createVNode("div", _hoisted_48, [
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>0?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>20?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>40?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>60?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>80?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent===100?'markActive':'']
                                  }, null, 2)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_49, [
                              _hoisted_50,
                              _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward,6)) + " LARIX", 1)
                            ]),
                            _createVNode("div", _hoisted_51, [
                              _createVNode("div", null, _toDisplayString(_ctx.t('reward.needUSDC')), 1),
                              _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.needUSDC,6)) + " USDC", 1)
                            ]),
                            _createVNode("div", _hoisted_52, [
                              _createVNode("div", _hoisted_53, [
                                _createVNode("div", _hoisted_54, _toDisplayString(_ctx.t('reward.stakeTime')), 1),
                                _createVNode("div", null, _toDisplayString(_ctx.stakePeriod) + " " + _toDisplayString(_ctx.t('reward.days')), 1)
                              ]),
                              _createVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createVNode("div", null, [
                                  _createVNode("img", {
                                    src: _ctx.larixImg,
                                    width: "20",
                                    height: "20",
                                    style: {"border-radius":"50%","vertical-align":"bottom"}
                                  }, null, 8, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.larixStakeLpDetals.apy,2)) + "% + ", 1),
                                  _createVNode("img", {
                                    src: _ctx.rayImg,
                                    width: "20",
                                    height: "20",
                                    style: {"border-radius":"50%","vertical-align":"bottom"}
                                  }, null, 8, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.larixStakeLpDetals.feeApy||0) + "% ", 1)
                                ])
                              ])
                            ]),
                            _createVNode(_component_q_btn, {
                              round: "",
                              "no-caps": "",
                              class: "button",
                              style: [{"margin":"2px 0 8px"}, !_ctx.stakeButtonDisable()?'background:#999999':''],
                              disable: !_ctx.stakeButtonDisable(),
                              onClick: _ctx.stakeLarix
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.borrowButtonText), 1)
                              ]),
                              _: 1
                            }, 8, ["disable", "style", "onClick"])
                          ], 512), [
                            [_vShow, _ctx.step === 2]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='xSol')
                      ? (_openBlock(), _createBlock("div", _hoisted_57, [
                          _createVNode("div", _hoisted_58, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_59, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "78",
                                  height: "78",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_60, [
                                  _createVNode("div", _hoisted_61, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_62, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_63, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_64, [
                                _createVNode("div", _hoisted_65, [
                                  _createVNode("div", _hoisted_66, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_67, [
                                  _createVNode("div", _hoisted_68, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_69, [
                                    _createVNode(_component_q_btn, {
                                      round: "",
                                      "no-caps": "",
                                      class: "button ",
                                      style: {"width":"100%","padding":"0 22px","margin-right":"10px","margin-bottom":"20px"},
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.claimReward('xSol')))
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("span", _hoisted_70, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='bonfida')
                      ? (_openBlock(), _createBlock("div", _hoisted_71, [
                          _createVNode("div", _hoisted_72, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_73, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "78",
                                  height: "78",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_74, [
                                  _createVNode("div", _hoisted_75, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_76, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_77, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_78, [
                                _createVNode("div", _hoisted_79, [
                                  _createVNode("div", _hoisted_80, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_81, [
                                  _createVNode("div", _hoisted_82, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_83, [
                                    _createVNode(_component_q_btn, {
                                      round: "",
                                      "no-caps": "",
                                      class: "button ",
                                      style: {"width":"100%","padding":"0 22px","margin-right":"10px","margin-bottom":"20px"},
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.claimReward('bonfida')))
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("span", _hoisted_84, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='larix')
                      ? (_openBlock(), _createBlock("div", _hoisted_85, [
                          _createVNode("div", _hoisted_86, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_87, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "78",
                                  height: "78",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_88, [
                                  _createVNode("div", _hoisted_89, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_90, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_91, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_92, [
                                _createVNode("div", _hoisted_93, [
                                  _createVNode("div", _hoisted_94, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_95, [
                                  _createVNode("div", _hoisted_96, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_97, [
                                    _createVNode(_component_q_btn, {
                                      round: "",
                                      "no-caps": "",
                                      class: "button ",
                                      style: {"width":"100%","padding":"0 22px","margin-right":"10px","margin-bottom":"20px"},
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.claimReward('larix')))
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("span", _hoisted_98, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='stepn')
                      ? (_openBlock(), _createBlock("div", _hoisted_99, [
                          _createVNode("div", _hoisted_100, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_101, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "78",
                                  height: "78",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_102, [
                                  _createVNode("div", _hoisted_103, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_104, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_105, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_106, [
                                _createVNode("div", _hoisted_107, [
                                  _createVNode("div", _hoisted_108, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_109, [
                                  _createVNode("div", _hoisted_110, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_111, [
                                    _createVNode(_component_q_btn, {
                                      round: "",
                                      "no-caps": "",
                                      class: "button ",
                                      style: {"width":"100%","padding":"0 22px","margin-right":"10px","margin-bottom":"20px"},
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.claimReward('larix')))
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("span", _hoisted_112, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='step')
                      ? (_openBlock(), _createBlock("div", _hoisted_113, [
                          _createVNode("div", _hoisted_114, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_115, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "78",
                                  height: "78",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_116, [
                                  _createVNode("div", _hoisted_117, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_118, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_119, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_120, [
                                _createVNode("div", _hoisted_121, [
                                  _createVNode("div", _hoisted_122, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_123, [
                                  _createVNode("div", _hoisted_124, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_125, [
                                    _createVNode(_component_q_btn, {
                                      round: "",
                                      "no-caps": "",
                                      class: "button ",
                                      style: {"width":"100%","padding":"0 22px","margin-right":"10px","margin-bottom":"20px"},
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.claimReward('larix')))
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("span", _hoisted_126, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_card, { class: "rewardApp lt-md" }, {
        default: _withId(() => [
          _createVNode(_component_q_card_section, { class: "row items-center rewardTitleApp" }, {
            default: _withId(() => [
              _createVNode("div", null, _toDisplayString(_ctx.dialogTitle), 1),
              _createVNode(_component_q_space),
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: ""
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "rewardBodyApp" }, {
            default: _withId(() => [
              (!_ctx.walletAddress)
                ? (_openBlock(), _createBlock("div", _hoisted_127, [
                    _createVNode("div", null, _toDisplayString(_ctx.t('wallet.connectToAWallet')), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_128, [
                    _createVNode("div", _hoisted_129, [
                      _createVNode("div", _hoisted_130, [
                        _createVNode("div", {
                          onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.poolType = 'main';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='main'?'active':'inactive'
                        }, _toDisplayString(_ctx.t("reward.main")), 3)
                      ]),
                      _createVNode("div", _hoisted_131, [
                        _createVNode("div", {
                          onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.poolType = 'larix';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='larix'?'active':'inactive'
                        }, "Larix", 2)
                      ]),
                      _createVNode("div", _hoisted_132, [
                        _createVNode("div", {
                          onClick: _cache[23] || (_cache[23] = ($event: any) => {_ctx.poolType = 'stepn';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='stepn'?'active':'inactive'
                        }, "Stepn", 2)
                      ]),
                      _createVNode("div", _hoisted_133, [
                        _createVNode("div", {
                          onClick: _cache[24] || (_cache[24] = ($event: any) => {_ctx.poolType = 'step';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='step'?'active':'inactive'
                        }, "Step", 2)
                      ]),
                      _createVNode("div", _hoisted_134, [
                        _createVNode("div", {
                          onClick: _cache[25] || (_cache[25] = ($event: any) => {_ctx.poolType = 'xSol';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='xSol'?'active':'inactive'
                        }, "XSOL", 2)
                      ]),
                      _createVNode("div", _hoisted_135, [
                        _createVNode("div", {
                          onClick: _cache[26] || (_cache[26] = ($event: any) => {_ctx.poolType = 'bonfida';_ctx.step=1;_ctx.confirmingClaim = false}),
                          class: _ctx.poolType==='bonfida'?'active':'inactive'
                        }, "Bonfida", 2)
                      ])
                    ]),
                    (_ctx.poolType==='main')
                      ? (_openBlock(), _createBlock("div", _hoisted_136, [
                          _withDirectives(_createVNode("div", _hoisted_137, [
                            (!_ctx.confirmingClaim)
                              ? (_openBlock(), _createBlock("div", _hoisted_138, [
                                  _createVNode("div", _hoisted_139, [
                                    _createVNode("img", {
                                      src: _ctx.larixImg,
                                      width: "49",
                                      height: "49",
                                      style: {"border-radius":"50%"}
                                    }, null, 8, ["src"]),
                                    _createVNode("div", _hoisted_140, [
                                      _createVNode("div", _hoisted_141, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                      _createVNode("div", _hoisted_142, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward,6)) + " LARIX", 1),
                                      _createVNode("div", _hoisted_143, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_144, [
                                    _createVNode("div", _hoisted_145, [
                                      _createVNode("div", _hoisted_146, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                      _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                    ]),
                                    _createVNode("div", _hoisted_147, [
                                      _createVNode("div", _hoisted_148, _toDisplayString(_ctx.t('wallet.price')), 1),
                                      _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                    ])
                                  ]),
                                  (_ctx.userLarixReward.isGreaterThan(0))
                                    ? (_openBlock(), _createBlock("div", _hoisted_149, [
                                        _createVNode("div", _hoisted_150, [
                                          _createVNode(_component_q_btn, {
                                            round: "",
                                            "no-caps": "",
                                            class: "button-app grey-button",
                                            style: {"margin-right":"6px","margin-bottom":"10px"},
                                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.confirmingClaim = true))
                                          }, {
                                            default: _withId(() => [
                                              _createVNode("span", _hoisted_151, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_btn, {
                                            round: "",
                                            "no-caps": "",
                                            class: "button-app grey-button",
                                            style: {"margin-bottom":"10px"},
                                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.step = 2,_ctx.rewardMultiplier = 5))
                                          }, {
                                            default: _withId(() => [
                                              _createVNode("span", _hoisted_152, _toDisplayString(_ctx.$t('reward.reward') + ' X ' + 5), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createVNode("div", _hoisted_153, [
                                          _createVNode(_component_q_btn, {
                                            round: "",
                                            "no-caps": "",
                                            class: "button-app",
                                            style: {"margin-bottom":"10px"},
                                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.step = 2,_ctx.rewardMultiplier = 10))
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('reward.reward') + ' X ' + 10), 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]))
                                    : (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        rounded: "",
                                        "no-caps": "",
                                        disabled: "",
                                        class: "button-app grey-button",
                                        style: {"margin-bottom":"20px"}
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                        ]),
                                        _: 1
                                      }))
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_154, [
                                  _hoisted_155,
                                  _createVNode("div", _hoisted_156, [
                                    _createVNode("div", null, _toDisplayString(_ctx.t('reward.youWillLose1',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(9),6)})), 1),
                                    _createVNode("div", _hoisted_157, _toDisplayString(_ctx.t('reward.youWillLose2',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(9),6)})), 1)
                                  ]),
                                  _createVNode(_component_q_btn, {
                                    round: "",
                                    "no-caps": "",
                                    class: "button-app",
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.step = 2))
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('reward.earn2x',{x:10})) + "(" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward.times(10),6)) + ") ", 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_btn, {
                                    round: "",
                                    "no-caps": "",
                                    class: "button-app grey-button bottom-btn-app",
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.claimReward('main')))
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('reward.claimDirectly')) + "(" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward,6)) + ") ", 1)
                                    ]),
                                    _: 1
                                  })
                                ]))
                          ], 512), [
                            [_vShow, _ctx.step === 1]
                          ]),
                          _withDirectives(_createVNode("div", _hoisted_158, [
                            _createVNode("div", _hoisted_159, [
                              _createVNode("p", _hoisted_160, _toDisplayString(_ctx.t('reward.chooseToReceive')), 1),
                              _createVNode(_component_q_btn, {
                                class: ["multiple-btn", _ctx.rewardMultiplier===10?'multiple-btnActive':''],
                                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.setRewardMultiplier(10))),
                                "no-caps": ""
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('reward.reward')) + " ×10", 1)
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              _createVNode(_component_q_btn, {
                                class: ["multiple-btn", _ctx.rewardMultiplier===5?'multiple-btnActive':''],
                                style: {"margin-left":"2%"},
                                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.setRewardMultiplier(5))),
                                "no-caps": ""
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.t('reward.reward')) + " ×5", 1)
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              _hoisted_161
                            ]),
                            _createVNode("div", _hoisted_162, _toDisplayString(_ctx.t('reward.maximumReceive',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(_ctx.rewardMultiplier),6)})) + " (" + _toDisplayString(_ctx.rewardMultiplier) + "X)", 1),
                            _createVNode("div", _hoisted_163, [
                              _createVNode("div", _hoisted_164, [
                                _createVNode("div", _hoisted_165, _toDisplayString(_ctx.t('reward.currentRewards')) + " (LARIX)", 1),
                                _createVNode("div", _hoisted_166, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userStakeLarixAmount,6)), 1)
                              ]),
                              _createVNode("div", _hoisted_167, [
                                _createVNode("div", _hoisted_168, _toDisplayString(_ctx.t('reward.stake')), 1),
                                _hoisted_169,
                                _createVNode("div", _hoisted_170, _toDisplayString(_ctx.stakePeriod) + " " + _toDisplayString(_ctx.t('reward.days')), 1)
                              ]),
                              _createVNode("div", _hoisted_171, [
                                _createVNode("div", _hoisted_172, _toDisplayString(_ctx.t('reward.expiredReward')) + " (LARIX)", 1),
                                _createVNode("div", _hoisted_173, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userTotalStakeLarixAmount,6)), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_174, _toDisplayString(_ctx.t('reward.walletBalance')) + " " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userUsdcBalance,2)) + " USDC, " + _toDisplayString(_ctx.t('reward.maximumReceive',{x:_ctx.formatBigNumberStr(_ctx.userLarixReward.times(_ctx.rewardMultiplier),6)})), 1),
                            _createVNode("div", _hoisted_175, [
                              _createVNode("div", _hoisted_176, [
                                _createVNode(_component_q_slider, {
                                  modelValue: _ctx.sliderStakePercent,
                                  "onUpdate:modelValue": [
                                    _cache[34] || (_cache[34] = ($event: any) => (_ctx.sliderStakePercent = $event)),
                                    _cache[35] || (_cache[35] = ($event: any) => (_ctx.sliderStakePercentChange($event)))
                                  ],
                                  style: {"height":"6px","z-index":"2","padding":"0 2px"},
                                  min: 0,
                                  max: 100
                                }, null, 8, ["modelValue"]),
                                _createVNode("div", _hoisted_177, [
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>0?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>20?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>40?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>60?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent>80?'markActive':'']
                                  }, null, 2),
                                  _createVNode("div", {
                                    class: ["sliderMarksText", _ctx.sliderStakePercent===100?'markActive':'']
                                  }, null, 2)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_178, [
                              _hoisted_179,
                              _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixReward,6)) + " LARIX", 1)
                            ]),
                            _createVNode("div", _hoisted_180, [
                              _createVNode("div", null, _toDisplayString(_ctx.t('reward.needUSDC')), 1),
                              _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.needUSDC,6)) + " USDC", 1)
                            ]),
                            _createVNode("div", _hoisted_181, [
                              _createVNode("div", _hoisted_182, [
                                _createVNode("div", _hoisted_183, _toDisplayString(_ctx.t('reward.stakeTime')), 1),
                                _createVNode("div", null, _toDisplayString(_ctx.stakePeriod) + " " + _toDisplayString(_ctx.t('reward.days')), 1)
                              ]),
                              _createVNode("div", _hoisted_184, [
                                _hoisted_185,
                                _createVNode("div", null, [
                                  _createVNode("img", {
                                    src: _ctx.larixImg,
                                    width: "14",
                                    height: "14",
                                    style: {"border-radius":"50%","vertical-align":"bottom"}
                                  }, null, 8, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatBigNumberStr(_ctx.larixStakeLpDetals.apy,2)) + "% + ", 1),
                                  _createVNode("img", {
                                    src: _ctx.rayImg,
                                    width: "14",
                                    height: "14",
                                    style: {"border-radius":"50%","vertical-align":"bottom"}
                                  }, null, 8, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.larixStakeLpDetals.feeApy||0) + "% ", 1)
                                ])
                              ])
                            ]),
                            _createVNode(_component_q_btn, {
                              round: "",
                              "no-caps": "",
                              class: "button-app",
                              style: [{"margin":"2px 0 8px"}, !_ctx.stakeButtonDisable()?'background:#999999':''],
                              disable: !_ctx.stakeButtonDisable(),
                              onClick: _ctx.stakeLarix
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.borrowButtonText), 1)
                              ]),
                              _: 1
                            }, 8, ["disable", "style", "onClick"])
                          ], 512), [
                            [_vShow, _ctx.step === 2]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='xSol')
                      ? (_openBlock(), _createBlock("div", _hoisted_186, [
                          _createVNode("div", _hoisted_187, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_188, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "49",
                                  height: "49",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_189, [
                                  _createVNode("div", _hoisted_190, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_191, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_192, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_193, [
                                _createVNode("div", _hoisted_194, [
                                  _createVNode("div", _hoisted_195, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_196, [
                                  _createVNode("div", _hoisted_197, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_198, [
                                    _createVNode("div", _hoisted_199, [
                                      _createVNode(_component_q_btn, {
                                        round: "",
                                        "no-caps": "",
                                        class: "button-app",
                                        style: {"margin-right":"6px","margin-bottom":"10px"},
                                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.claimReward('xSol')))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("span", _hoisted_200, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button-app grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='bonfida')
                      ? (_openBlock(), _createBlock("div", _hoisted_201, [
                          _createVNode("div", _hoisted_202, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_203, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "49",
                                  height: "49",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_204, [
                                  _createVNode("div", _hoisted_205, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_206, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_207, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_208, [
                                _createVNode("div", _hoisted_209, [
                                  _createVNode("div", _hoisted_210, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_211, [
                                  _createVNode("div", _hoisted_212, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_213, [
                                    _createVNode("div", _hoisted_214, [
                                      _createVNode(_component_q_btn, {
                                        round: "",
                                        "no-caps": "",
                                        class: "button-app ",
                                        style: {"margin-right":"6px","margin-bottom":"10px"},
                                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.claimReward('bonfida')))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("span", _hoisted_215, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button-app grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='larix')
                      ? (_openBlock(), _createBlock("div", _hoisted_216, [
                          _createVNode("div", _hoisted_217, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_218, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "49",
                                  height: "49",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_219, [
                                  _createVNode("div", _hoisted_220, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_221, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_222, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_223, [
                                _createVNode("div", _hoisted_224, [
                                  _createVNode("div", _hoisted_225, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_226, [
                                  _createVNode("div", _hoisted_227, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_228, [
                                    _createVNode("div", _hoisted_229, [
                                      _createVNode(_component_q_btn, {
                                        round: "",
                                        "no-caps": "",
                                        class: "button-app ",
                                        style: {"margin-right":"6px","margin-bottom":"10px"},
                                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.claimReward('larix')))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("span", _hoisted_230, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button-app grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='stepn')
                      ? (_openBlock(), _createBlock("div", _hoisted_231, [
                          _createVNode("div", _hoisted_232, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_233, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "49",
                                  height: "49",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_234, [
                                  _createVNode("div", _hoisted_235, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_236, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_237, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_238, [
                                _createVNode("div", _hoisted_239, [
                                  _createVNode("div", _hoisted_240, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_241, [
                                  _createVNode("div", _hoisted_242, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_243, [
                                    _createVNode("div", _hoisted_244, [
                                      _createVNode(_component_q_btn, {
                                        round: "",
                                        "no-caps": "",
                                        class: "button-app ",
                                        style: {"margin-right":"6px","margin-bottom":"10px"},
                                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.claimReward('larix')))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("span", _hoisted_245, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button-app grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.poolType==='step')
                      ? (_openBlock(), _createBlock("div", _hoisted_246, [
                          _createVNode("div", _hoisted_247, [
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_248, [
                                _createVNode("img", {
                                  src: _ctx.larixImg,
                                  width: "49",
                                  height: "49",
                                  style: {"border-radius":"50%"}
                                }, null, 8, ["src"]),
                                _createVNode("div", _hoisted_249, [
                                  _createVNode("div", _hoisted_250, _toDisplayString(_ctx.t('wallet.unclaimedBalance')), 1),
                                  _createVNode("div", _hoisted_251, _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward,6)) + " LARIX", 1),
                                  _createVNode("div", _hoisted_252, "≈$" + _toDisplayString(_ctx.formatBigNumberStr(_ctx.userLarixLaunchpadDetails.userLarixReward.times(_ctx.larixPrice),2)), 1)
                                ])
                              ]),
                              _createVNode("div", _hoisted_253, [
                                _createVNode("div", _hoisted_254, [
                                  _createVNode("div", _hoisted_255, _toDisplayString(_ctx.t('wallet.walletBalance')), 1),
                                  _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(_ctx.walletLarixBalance,2)) + " LARIX", 1)
                                ]),
                                _createVNode("div", _hoisted_256, [
                                  _createVNode("div", _hoisted_257, _toDisplayString(_ctx.t('wallet.price')), 1),
                                  _createVNode("div", null, "$" + _toDisplayString(_ctx.larixPrice.toFixed(4,1)), 1)
                                ])
                              ]),
                              (_ctx.userLarixLaunchpadDetails.userLarixReward.isGreaterThan(0))
                                ? (_openBlock(), _createBlock("div", _hoisted_258, [
                                    _createVNode("div", _hoisted_259, [
                                      _createVNode(_component_q_btn, {
                                        round: "",
                                        "no-caps": "",
                                        class: "button-app ",
                                        style: {"margin-right":"6px","margin-bottom":"10px"},
                                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.claimReward('larix')))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("span", _hoisted_260, _toDisplayString(_ctx.t('wallet.harvest')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    rounded: "",
                                    "no-caps": "",
                                    disabled: "",
                                    class: "button-app grey-button",
                                    style: {"margin-bottom":"20px"}
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.t('wallet.nothingToClaim')), 1)
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
})